module.exports = __webpack_public_path__ + "static/media/iphone6_splash.d64f7874.png";